import React, { useState } from 'react';
import styles from '../Sidebar/Sidebar.module.css';
import Imagenes from '../../../images/logoturismo.png';
import SolicitudLogo from '../../../images/crearsolicitud.png';
import Logossoli from '../../../images/21.png';
import cambiologo from '../../../images/32.png';
import Logofflogo from '../../../images/cierresesion.png';
import { logout } from '../../../redux/actions/auth';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import confusuario from '../../../images/confuser.png';

const AdminSidebar = ({ logout, open, setOpen, showToggle }) => {
    const [redirect, setRedirect] = useState(false);

    const logoutHandler = () => {
        logout();
        setRedirect(true);
    };

    if (redirect) {
        window.location.reload(false);
        window.location.href = '/';
    }

    // El fondo oscuro cubre toda la pantalla: un clic fuera del panel (o en un enlace) lo cierra
    const handleSidebarClick = () => {
        setOpen(!open);
    };

    return (
        <>
            {open ? (
                <div className={styles.backdrop} onClick={handleSidebarClick}>
                    <div className={styles.panel}>
                        <img className='img-ecoturismo' src={Imagenes} alt="DUOC ECOTURISMO" />
                        <hr />
                        <div className={styles.columns}>
                            <ul className={styles.list}>

                                 <Link className={styles.item} to='/landing'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logossoli} alt="" />
                                        <p className={styles.itemText}>Resolver solicitudes</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/indicadores'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={SolicitudLogo} alt="" />
                                        <p className={styles.itemText}>Indicadores</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='../ListaProductos'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={SolicitudLogo} alt="" />
                                        <p className={styles.itemText}>Modificar inventario</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/GestionarUsuarios'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={confusuario} alt="" />
                                        <p className={styles.itemText}>Gestionar cuentas de usuario</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/GestionarTalleres'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={confusuario} alt="" />
                                        <p className={styles.itemText}>Gestionar talleres</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/indicadores/configuracion'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={confusuario} alt="" />
                                        <p className={styles.itemText}>Configurar indicadores</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/CambioContrasena'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={cambiologo} alt="" />
                                        <p className={styles.itemText}>Cambio de contraseña</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/' onClick={logoutHandler}>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logofflogo} alt="" />
                                        <p className={styles.itemText}>Cerrar sesión</p>
                                        </div>
                                </Link>
                            </ul>

                        </div>
                    </div>
                </div>
            ) : showToggle && (
                <button onClick={handleSidebarClick} className={styles.toggle}>
                    ❯
                </button>
            )}
        </>
    );
};

export default connect(null, {
    logout
})(AdminSidebar);
